<template>
  <div class="modal fade" id="modalConfirmacionRedirige" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="col-form-label">{{cuerpo}}</p>          
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="btnRecargarAltaRedirige" data-dismiss="modal"><i class="fas fa-times"></i> <b>Cancelar</b></button>
          <button type="button" class="btn btn-primary" id="btnConfirmarEdicionRedirige" data-dismiss="modal"><i class="fas fa-edit"></i> <b>Editar Usuario</b></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>  
  import Vue from 'vue'

  export default {
    props: {
      method: {type: Function},
    },
    data() {
      return {
        titulo: "",
        cuerpo: ""
      }
    },
    components: {
    },
    methods: {
      mostrar: function (titulo, cuerpo) {        
        this.titulo = titulo
        this.cuerpo = cuerpo
        // $('#btnModalConfirmarEdicion').attr("disabled", true)
        this.fecha = "";
        $('#modalConfirmacionRedirige').modal();
        $("#btnRecargarAltaRedirige").unbind('click').click(this.RecargarAlta);
        $("#btnConfirmarEdicionRedirige").unbind('click').click(this.ConfirmarEdicion);
      },
      ConfirmarEdicion: function () {
        this.$emit('decisionDelUsuario', true);
      },
      RecargarAlta:function(){
        this.$emit('decisionDelUsuario',false);
      } 
    },
    computed: {    
    },
    mounted: function () {
    }
  }
</script>
<style scoped>
  .modal {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1050;
      /* display: none; */
      overflow: hidden;
      outline: 0;
    }
    .modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
          background-color:  #007573;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/Modales/ModalRedirigeUsuario.vue